import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a266085"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-panel version-control" }
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "controller-title" }, " 服务版本升级 ", -1))
const _hoisted_4 = { class: "controller-extra" }
const _hoisted_5 = {
  key: 0,
  class: "new-version-badge"
}
const _hoisted_6 = { class: "service-list" }
const _hoisted_7 = { class: "intro" }
const _hoisted_8 = { class: "intro-name" }
const _hoisted_9 = { class: "intro-extra" }
const _hoisted_10 = { class: "intro-ver" }
const _hoisted_11 = {
  key: 0,
  class: "description"
}
const _hoisted_12 = { class: "section-content" }
const _hoisted_13 = { class: "setting-box autoupgrade-setting" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "自动升级"),
  /*#__PURE__*/_createElementVNode("p", null, "服务自动升级，勾选系统会在设备负载低时，自动进行升级")
], -1))

import { ref, computed } from 'vue'
import Switch from '@remote/components/switchbox/Switch.vue'
import SVGIcon from '@remote/components/SVGIcon.vue'
import { useHeziVersionStore } from '@remote/store/version'
import { useHeziSettingsStore } from '@remote/store/settings'
import VersionDetection from '@remote/components/business/version/detection.vue'
import { translateServiceList, getServiceDescription, mocklist } from '@remote/views/services/helper'
import lang from '@remote/views/services/lang'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { state: hzVersionSetting, toggleAutograde } = useHeziSettingsStore()
const { state: hzVersionState } = useHeziVersionStore()
const hasNewVersion = computed(() => hzVersionState.hasNewVersion)
const list = computed(() => {
  const versionStore = hzVersionState.versionStore
  const list = translateServiceList(versionStore)
  if (!list.length) return mocklist
  return list
})
const $t = computed(() => lang.ServiceListPage)
const isExpand = ref(false)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "setting-box version-controller",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpand.value = !isExpand.value))
      }, [
        _createElementVNode("div", {
          class: "controller-header",
          style: _normalizeStyle({ marginBottom: isExpand.value ? '16px' : '0' })
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_unref(hasNewVersion))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(["expand-icon", isExpand.value ? 'arrow-up' : 'arrow-down'])
            }, [
              _createVNode(SVGIcon, { name: "chevron" })
            ], 2)
          ])
        ], 4),
        _createElementVNode("div", {
          class: _normalizeClass(["controller-content", isExpand.value ? 'is-expanded': 'is-collapsed'])
        }, [
          _createVNode(VersionDetection),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (service) => {
              return (_openBlock(), _createElementBlock("li", {
                key: service.appid,
                class: "service-item"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(service.name), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, "V " + _toDisplayString(service.current), 1)
                  ])
                ]),
                (!!(_unref($t).description[service.appid]))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(getServiceDescription)(service.appid)), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", {
          class: "setting-switchbox",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(toggleAutograde)()))
        }, [
          _createVNode(Switch, {
            value: _unref(hzVersionSetting).isAutoUpgrade
          }, null, 8, ["value"])
        ])
      ])
    ])
  ]))
}
}

})